import { render, staticRenderFns } from "./TestResults.vue?vue&type=template&id=3effc6c4&"
import script from "./TestResults.vue?vue&type=script&lang=ts&"
export * from "./TestResults.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports